export function All() {
    return function (obj, _, d) {
        var _a;
        var proto = obj;
        var config = (_a = proto[MEMOIZE_CONFIGURATION_KEY]) !== null && _a !== void 0 ? _a : { memoizers: 0 };
        if (d.value != null) {
            d.value = impl(d.value, config);
        }
        else if (d.get != null) {
            d.get = impl(d.get, config);
        }
        else {
            throw "Decorator can only be applied to a method or getter";
        }
        config.memoizers += 1;
        proto[MEMOIZE_CONFIGURATION_KEY] = config;
    };
}
var getCacheKey = function (name) { return "__designed_memoize_all_".concat(name); };
function impl(original, config) {
    var name = original.name;
    var cacheProp = getCacheKey("".concat(name, "-").concat(config.memoizers));
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.hasOwnProperty(cacheProp)) {
            return this[cacheProp];
        }
        var value = original.apply(this, args);
        Object.defineProperty(this, cacheProp, {
            writable: true,
            configurable: true,
            enumerable: false,
            value: value
        });
        return value;
    };
}
export var MEMOIZE_CONFIGURATION_KEY = Symbol("MEMOIZE_CONFIGURATION");
